import { getDateTime } from "../../services/CheckMeProBlePackages";
var PACKAGESIZE = 12;
export function parseSPO2Items(bytes) {
    var start = 0;
    var returnList = new Array();
    for (var k = 0; k < bytes.length - 8; k++) {
        if (start + PACKAGESIZE >= bytes.length)
            break;
        var user = {};
        returnList.push(user);
        start = k * PACKAGESIZE;
        user.date = getDateTime(bytes, start);
        user.measuringMode = bytes[start + 7];
        user.oxygen = bytes[start + 8];
        user.pr = bytes[start + 9];
        user.pi = bytes[start + 10];
    }
    return returnList;
}
